namespace GeniuzPOS.Inventory {
    export class IcStockTranColumns {
        static columnsKey = 'Inventory.IcStockTran';
    }
}
